import { Link } from 'react-router-dom'
import Logo from '../../assets/svg/logo.svg?react'

export const HeaderLogo = () => {
  return (
    <h2 className="font-robot">
      <Link to="/">
        <Logo />
      </Link>
    </h2>
  )
}
